
<template>
  <eye-exam-card
    class="medical-record-exam-view"
    title="Ceratoscopia"
    :patient-id="patientId"
    :record-id="recordId"
    :exam-id="examId"
    :inputs="data"
    :rows-definition="table.body"
    :date="date"
    @edit="$emit('edit')"
    :show-edit-button="showEditButton"
  />
</template>

<script>
import formatters from '@/filters';
import EyeExamCard from '../ophtalmology/EyeExamCard.vue';

export default {
  name: 'KeratoscopyView',
  components: {
    EyeExamCard,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    patientId: {
      type: String,
      required: false,
    },
    recordId: {
      type: String,
      required: false,
    },
    examId: {
      type: String,
      required: false,
    },
    date: {
      type: String,
      required: false,
    },
    showEditButton: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      table: {
        body: [
          {
            label: 'Astigmatismo DK',
            R: 'astigmatismDkR',
            L: 'astigmatismDkL',
            formatter: formatters.diopter,
          },
          {
            label: 'K1 (Flat plano)',
            R: ['k1R', 'k1AxisR'],
            L: ['k1L', 'k1AxisL'],
            formatter: this.formatKeratometry,
          },
          {
            label: 'K2 (Steep curvo)',
            R: ['k2R', 'k2AxisR'],
            L: ['k2L', 'k2AxisL'],
            formatter: this.formatKeratometry,
          },
          {
            label: 'Kmax',
            R: 'kmaxR',
            L: 'kmaxL',
            formatter: formatters.diopter,
          },
        ],
      },
    };
  },
  methods: {
    formatKeratometry(value, axis) {
      if (!value && !axis) return '';
      return [formatters.diopter(value), formatters.deg(axis)].filter(v => v !== '').join(' @ ');
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";
</style>
